import { render } from "./DeletedLabs.vue?vue&type=template&id=514685ee&scoped=true"
import script from "./DeletedLabs.vue?vue&type=script&lang=js"
export * from "./DeletedLabs.vue?vue&type=script&lang=js"

import "./DeletedLabs.vue?vue&type=style&index=0&id=514685ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514685ee"]])

export default __exports__